import { expandValue } from 'lib/rpcts'
import { App } from 'pbts/c1/api/app/v1/app'
import { AppVaultBinding, AppVaultBindingRef, AppVaultBindingView, Vault, VaultRef } from 'pbts/c1/api/vault/v1/vault'
import {
    AppVaultBindingServiceClient,
    VaultOpenerServiceClient,
    VaultServiceClient,
} from 'pbts/c1/api/vault/v1/vault.client'
import { Any } from 'pbts/google/protobuf/any'
import { createMutationApi } from './lib/createMutationApi'
import { createPagedListApi } from './lib/createPagedListApi'
import { createUnaryApi } from './lib/createUnaryApi'

export const listVaultsApi = createPagedListApi(
    VaultServiceClient,
    'list',
    (response) => response.list,
    VaultRef.typeName,
)
export const createVaultApi = createMutationApi(VaultServiceClient, 'create', undefined, VaultRef.typeName)
export const getVaultApi = createUnaryApi(VaultServiceClient, 'get')
export const deleteVaultApi = createMutationApi(VaultServiceClient, 'delete', undefined, VaultRef.typeName)
export const updateVaultApi = createMutationApi(VaultServiceClient, 'update', undefined, VaultRef.typeName)

export const createAppVaultBindingsApi = createMutationApi(
    AppVaultBindingServiceClient,
    'create',
    undefined,
    AppVaultBindingRef.typeName,
)
export const deleteAppVaultBindingsApi = createMutationApi(
    AppVaultBindingServiceClient,
    'delete',
    undefined,
    AppVaultBindingRef.typeName,
)

export interface AppVaultBindingValue extends AppVaultBinding {
    vault?: Vault
    app?: App
}

export const expandAppVaultBindingValue = (msg: AppVaultBindingView | undefined, values: Any[]): AppVaultBindingValue => {
    const u: AppVaultBindingValue = AppVaultBinding.create(msg?.appVaultBinding ?? {})
    u.vault = expandValue<Vault>(msg?.vaultPath || '', Vault, values)
    u.app = expandValue<App>(msg?.appPath || '', App, values)
    return u
}

export const listAppVaultBindingsApi = createPagedListApi(
    AppVaultBindingServiceClient,
    'list',
    (response) => response.list.map((v) => expandAppVaultBindingValue(v, response.expanded)),
    AppVaultBindingRef.typeName,
)

export const openVaultApi = createUnaryApi(
    VaultOpenerServiceClient,
    'open',
)

export const listVaultOwnersApi = createUnaryApi(
    VaultServiceClient,
    'listOwners',
)

export const setVaultOwnersApi = createMutationApi(
    VaultServiceClient,
    'setOwners',
    undefined,
    VaultRef.typeName,
)

export const searchVaultsApi = createPagedListApi(
    VaultServiceClient,
    'search',
    (response) => response.list,
    VaultRef.typeName,
)

export const searchVaultsForOwnerApi = createPagedListApi(
    VaultServiceClient,
    'searchVaultsForOwner',
    (response) => response.list,
    VaultRef.typeName,
)

export const getUserCanViewVaultsApi = createUnaryApi(
    VaultServiceClient,
    'getUserCanViewVaults',
)
